const deleteCompareModalInitialState = {
  open:         false,
  isSingleDoor: false,
};

export default deleteCompareModalInitialState;